import React, { useState } from 'react'
import Tabs, { TabPanel, TabTrigger, TabTriggerGroup } from '@zera-admin/tabs'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { string } from '@zera-admin/helpers'
import { Column, Row } from '@zera-admin/page'

import { getFieldOptions } from 'bi-tool/visualizations/visualization/getters'

import * as Styled from './InfluentialMapDefinitions.styled'
import { InfluentialMapDefinitionsProps } from './types'

const InfluentialMapDefinitions: React.FunctionComponent<InfluentialMapDefinitionsProps> =
  ({ aggregations = [], fields = [], groups = [], options, onChange }) => {
    const [fieldOptions, setFieldOptions] = useState<SelectOptionProps[]>(
      getFieldOptions(fields)
    )

    const handleChangeFieldInput = (value: string) => {
      const option = {
        label: value,
        value,
      }
      const index = fieldOptions.findIndex(
        (reference) => reference.value === parseInt(option.value)
      )
      let optionsInstance = [...fieldOptions]

      if (value && index === -1) {
        optionsInstance[0] = option
      } else {
        optionsInstance = getFieldOptions(fields)
      }

      setFieldOptions(optionsInstance)
    }

    const renderTabs = () => {
      return (
        <Tabs id="tabs">
          <TabTriggerGroup>
            <TabTrigger>Veri</TabTrigger>
          </TabTriggerGroup>
          <TabPanel>{renderDataTab()}</TabPanel>
        </Tabs>
      )
    }

    const renderDataTab = () => {
      return (
        <Row xs={{ direction: 'column' }}>
          <Column>
            <Select
              name="column"
              options={fieldOptions}
              onChange={(props) => {
                onChange({
                  ...options,
                  country: (props as SelectOptionProps).value as string,
                })
              }}
              onInputChange={handleChangeFieldInput}
              value={
                options.country
                  ? {
                      label: string.textify(options.country),
                      value: options.country,
                    }
                  : { label: '', value: '' }
              }
              label="Ülke"
              placeholder="Seçim yapınız"
              description="Harita üzerinde gösterilecek ülke alanını seçin"
            />
          </Column>
          <Column>
            <Styled.InfluentialMapDefinitionField>
              <Row>
                <Column>
                  <Select
                    name="column"
                    options={fieldOptions}
                    onChange={(props) => {
                      onChange({
                        ...options,
                        count: (props as SelectOptionProps).value as string,
                      })
                    }}
                    onInputChange={handleChangeFieldInput}
                    value={
                      options.count
                        ? {
                            label: string.textify(options.count),
                            value: options.count,
                          }
                        : { label: '', value: '' }
                    }
                    label="Değer"
                    placeholder="Seçim yapınız"
                    description="Harita üzerinde gösterilecek değer alanını seçin"
                    // isDisabled={
                    //   aggregations.length || groups.length ? true : false
                    // }
                  />
                </Column>
              </Row>
            </Styled.InfluentialMapDefinitionField>
          </Column>
        </Row>
      )
    }

    return (
      <Styled.InfluentialMapDefinitions>
        {renderTabs()}
      </Styled.InfluentialMapDefinitions>
    )
  }

export default InfluentialMapDefinitions
